import * as React from 'react';
import { FlooringLayoutProps } from './FlooringLayoutAssets';
export const ClassiqueVertical = ({ props }: { props: FlooringLayoutProps }) => {
    const { fillColor = '#13123A', svgProps } = props;
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
            <path d="M2.398 45.6V2.4h43.2v43.2z" fill="#fff" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 48V0h48v48zm2.4-2.4h43.2V2.4H2.4z" fill={fillColor} />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.6 38.4v7.2H7.2V26.4h-6V24h6V2.4h2.4v8.4h4.8V2.4h2.4V24h6V2.4h2.4v8.4H30V2.4h2.4V24h4.8V2.4h2.4v8.4h6v2.4h-6V36h6v2.4h-6v7.2h-2.4V26.4h-4.8v19.2H30v-7.2h-4.8v7.2h-2.4V26.4h-6v19.2h-2.4v-7.2zm0-2.4h4.8V13.2H9.6zm15.6 0H30V13.2h-4.8z"
                fill={fillColor}
            />
        </svg>
    );
};
